export default __webpack_public_path__ + "static/media/S2-main-vid.a7221636.mp4";